const ui = require( './ui.js' );
const utils = require( './utilities.js' );

function cacheSelectors() {
    let $sel = {
        'form': {
            '$updateLogin': $('.form-update-login'),
            '$updateAccount': $('.form-update-account'),
            '$updateTwofa': $('.form-update-twofa')
        },
        'modal': {
            '$twofa': $('.modal--twofa'),
            '$backup': $('.modal--backup'),
        }
    };
    $sel.input = {
        '$loginFields': $sel.form.$updateLogin.find('.listitem--input'),
        '$accountFields': $sel.form.$updateAccount.find('.listitem--input'),
        '$twofaFields': $sel.form.$updateTwofa.find('.listitem--input'),
        '$passwordToggle': $sel.form.$updateLogin.find('.password--toggle'),
        '$formStart': $('.form-start'),
        '$getTwofaToken': $('.get-twofa-token'),
        '$tokenInput': $sel.modal.$twofa.find('.input'),
        '$submitTwoFa': $sel.modal.$twofa.find('.twofa-submit'),
        '$disableTwoFa': $sel.modal.$twofa.find('.twofa-disable'),
        '$resendTwoFa': $sel.modal.$twofa.find('#resend'),
        '$backupCode': $sel.modal.$backup.find('.backup-code'),
    };
    $sel.twofa = {
        '$modalSubmit': $('.modalSubmit'),
        '$container': $('.twofa'),
        '$modalStatus': $('.twofa--status'),
        '$step1': $sel.modal.$twofa.find('.step-1'),
        '$step2': $sel.modal.$twofa.find('.step-2'),
        '$getBackup': $sel.modal.$twofa.find('.twofa-backup'),
    };
    return $sel;
}

function init() {
    const $sel = cacheSelectors();

    $sel.input.$formStart.on('click keyup', function(e) {
        if(e.keyCode && e.keyCode !== 13) {
            return;
        }
        else if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
        }
        $('.post-submit').remove();

        if($(this).hasClass('submit')) {
            if($(this).parent('.form').hasClass('form-update-account')) {
                updateAccount();
            }
            else {
                updateLogin();
            }
        }
        else {
            $(this).addClass('btn submit');
            $(this).parent('.form').addClass('active');
        }
    });

    $sel.input.$loginFields.filter('#password').on('keyup focusout', (e, el) => {
        utils.form.validatePassword(e, $(el));
    });

    $sel.input.$passwordToggle.on('click', () => {
        utils.form.togglePassword($sel.input.$loginFields);
    });

    $sel.form.$updateAccount.on('keyup', utils.debounce((e) => {
        if($sel.form.$updateAccount.hasClass('active') ) {
            utils.form.handleSubmit(e, updateAccount);
        }
    }));

    $sel.form.$updateLogin.on('keyup', utils.debounce((e) => {
        if($sel.form.$updateLogin.hasClass('active')) {
            utils.form.handleSubmit(e, updateLogin);
        }
    }));

    $sel.input.$submitTwoFa.on('click', enableTwoFa);
    $sel.input.$tokenInput.on('keyup', utils.debounce((e) => {
        utils.form.handleSubmit(e, enableTwoFa);
    }));
    $sel.input.$resendTwoFa.on('click', () => {
        $sel.input.$tokenInput.val('');
        enableTwoFa()
    });
    $sel.twofa.$getBackup.on('click', getBackup);

    $sel.input.$disableTwoFa.on('click', disableTwoFa);

    function updateAccount() {
        let data = {};
        utils.form.prepareRequest($sel.input.$accountFields, data);
        if(!utils.form.isProcessing) {
		    ui.loader.show();
            utils.form.isProcessing = true;
            console.log($sel.input.$accountFields, data);
            const post = $.ajax({
                method: 'POST',
                url: '/wp-json/alterwood/v1/update-account', 
                data: data,
                beforeSend: function ( xhr ) {
                    xhr.setRequestHeader( 'X-WP-Nonce', $sel.form.$updateLogin.data('nonce') );
                },
            });
            post.always((res) => {
                console.log(res);
                if (res.status === 'error' || res.code === 'rest_cookie_invalid_nonce') {
                    console.log('error');
                } else {
                    $sel.input.$formStart.removeClass('btn submit').after('<p class="post-submit">Changes Saved</p>')
                    $sel.form.$updateAccount.removeClass('active');
                    $sel.input.$accountFields.each(function(i, el) {
                        $(el).siblings('.listitem--text').text($(el).val());
                    });
                }
                utils.form.isProcessing = false;
                ui.loader.hide();
            });
        }
    }
    function updateLogin() {
        let data = {};
        if (utils.form.prepareRequest($sel.input.$loginFields, data) && !utils.form.isProcessing) {
            utils.form.isProcessing = true;
            ui.loader.show();
            const post = $.ajax({
                method: 'POST',
                url: '/wp-json/alterwood/v1/update-login', 
                data: data,
                beforeSend: function ( xhr ) {
                    xhr.setRequestHeader( 'X-WP-Nonce', $sel.form.$updateLogin.data('nonce') );
                },
            });
            post.always((res) => {
                console.log(res);
                if (res.status === 'error' || res.code === 'rest_cookie_invalid_nonce') {
                    console.log('error');
                } else {
                    $sel.input.$formStart.removeClass('btn submit').after('<p class="post-submit">Changes Saved</p>')
                    $sel.form.$updateLogin.removeClass('active');
                    window.location.reload();
                }
                utils.form.isProcessing = false;
                ui.loader.hide();
            });
        }
    }
    function disableTwoFa() {
        if(!utils.form.isProcessing) {
            utils.form.isProcessing = true;
            ui.loader.show();
            const post = $.ajax({
                method: 'POST',
                url: '/wp-json/alterwood/v1/two-fa-disable',
                beforeSend: function ( xhr ) {
                    xhr.setRequestHeader( 'X-WP-Nonce', $sel.form.$updateLogin.data('nonce') );
                },
            });
            post.always((res) => {
                console.log(res);
                if (res.status === 'error' || res.code === 'rest_cookie_invalid_nonce') {
                    console.log('error', res);
                } else {
                    $sel.twofa.$container.removeClass('active');
                    $sel.modal.$twofa.removeClass('twofa-active');
                    ui.modal.hide();
                }
                utils.form.isProcessing = false;
                ui.loader.hide();
            });
        }
    }
    function enableTwoFa() {
        let data = {};
        if (utils.form.prepareRequest($sel.input.$tokenInput, data) && !utils.form.isProcessing) {
            ui.loader.show();
            utils.form.isProcessing = true;
            const post = $.ajax({
                method: 'POST',
                url: '/wp-json/alterwood/v1/two-fa-enable',
                data: data,
                beforeSend: function ( xhr ) {
                    xhr.setRequestHeader( 'X-WP-Nonce', $sel.modal.$twofa.data('nonce') );
                },
            });
            post.always((res) => {
                console.log(res);
                if (res.status === 'error' || res.code === 'rest_cookie_invalid_nonce') {
                    console.log('error', res);
                    $sel.modal.$twofa.find('.modal__notice').remove();
                    $sel.input.$tokenInput.after('<p class="modal__notice error">' + res.message + '</p>');
                } else if (res.status === 'step 2') {
                    $sel.twofa.$step1.hide();
                    $sel.twofa.$step2.show();
                    $sel.input.$tokenInput.focus();
                } else if (res.status === 'success') {
                    ui.modal.hide();
                    $sel.twofa.$step1.show();
                    $sel.twofa.$step2.hide();
                    $sel.modal.$twofa.find('.modal__notice').remove();
                    
                    $sel.twofa.$container.addClass('active');
                    $sel.modal.$twofa.addClass('twofa-active');

                    $sel.input.$backupCode.text(res.backup_code);
                    ui.modal.show($sel.modal.$backup);
                }
                utils.form.isProcessing = false;
                ui.loader.hide();
            });
        }
    }
    function getBackup() {
        $sel.input.$backupCode.text('######');
        let data = {};
        if (!utils.form.isProcessing) {
            ui.loader.show();
            utils.form.isProcessing = true;
            const post = $.ajax({
                method: 'POST',
                url: '/wp-json/alterwood/v1/get-backup-code',
                data: data,
                beforeSend: function ( xhr ) {
                    xhr.setRequestHeader( 'X-WP-Nonce', $sel.modal.$backup.data('nonce') );
                },
            });
            post.always((res) => {
                console.log(res);
                if (res.status === 'error' || res.code === 'rest_cookie_invalid_nonce') {
                    console.log('error', res);
                    $sel.modal.$backup.find('.modal__notice').remove();
                    $sel.input.$backupCode.after('<p class="modal__notice error">' + res.message + '</p>');
                } else if (res.status === 'success') {
                    $sel.input.$backupCode.text(res.backup_code);
                }
                utils.form.isProcessing = false;
                ui.loader.hide();
            });
        }
    }
}

/**
 * Public API
 *
 * @type {Object}
 */
 module.exports = {
	init: init
};


// WEBPACK FOOTER //
// ./scripts/components/accounts.js